// @ts-strict-ignore
import apisauce from 'apisauce'
import { Configuration, MemberSSOApiFactory, UserApiFactory } from '@dialogue/multipass'
import { select, call } from 'typed-redux-saga'

import Config from 'APP/Config'
import { RootState } from 'APP/Store/CreateStore'

export const selectAccessToken = (state: RootState) => state.login.accessToken

export function* getClientConfig() {
  const accessToken = yield* select(selectAccessToken)

  if (!accessToken) {
    throw new Error('Missing access token')
  }

  if (!Config.MULTIPASS_DOMAIN) {
    throw new Error('Multipass domain is not set')
  }

  return new Configuration({
    accessToken,
    basePath: Config.MULTIPASS_DOMAIN,
  })
}

export function* getAxiosClient() {
  const accessToken = yield* select(selectAccessToken)

  if (!accessToken) {
    throw new Error('Missing access token')
  }

  if (!Config.MULTIPASS_DOMAIN) {
    throw new Error('Multipass domain is not set')
  }

  const apiClient = apisauce.create({
    baseURL: Config.MULTIPASS_DOMAIN,
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return apiClient.axiosInstance
}

export function* getMemberSSOApi() {
  const axiosInstance = yield* call(getAxiosClient)
  return MemberSSOApiFactory(yield* call(getClientConfig), '', axiosInstance)
}

export function* getUsersApi() {
  const axiosInstance = yield* call(getAxiosClient)
  return UserApiFactory(yield* call(getClientConfig), '', axiosInstance)
}
